import { render, staticRenderFns } from "./eventTypes.vue?vue&type=template&id=590a55fc&scoped=true"
import script from "./eventTypes.vue?vue&type=script&lang=js"
export * from "./eventTypes.vue?vue&type=script&lang=js"
import style0 from "./eventTypes.vue?vue&type=style&index=0&id=590a55fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590a55fc",
  null
  
)

export default component.exports